import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	width: 200px;
	height: 80px;
	padding-left: 20px;
	padding-top: 17px;
	padding-bottom: 16px;
	border-radius: 10px;
	background: (255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	overflow: hidden;
	cursor: pointer;

	&:hover {
		background: #fff;
	}

	&.active {
		background: #2d70da;
	}

	transition: background 0.25s ease;
`;

const StyledBackgroundNumber = styled.div<{
	$color?: string;
}>`
	position: absolute;
	top: 50%;
	right: -20px;
	transform: translateY(-49%);
	font-family: 'GT Walsheim Pro';
	font-weight: bold;
	font-size: 120px;
	line-height: 137px;
	color: #ffffff;
	mask-image: linear-gradient(90deg, #000000 50%, rgba(0, 0, 0, 0.5) 100%);
	opacity: 0.05;
	pointer-events: none;
	transition: color 0.25s ease;

	${StyledContainer}:hover & {
		color: #000000;
		opacity: 0.1;
	}

	${StyledContainer}.active & {
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledInnerContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;

	> div {
		font-family: 'GT Walsheim Pro';
		font-weight: bold;
		font-size: 14px;
		text-transform: uppercase;
		color: #fff;
		transition: color 0.25s ease;

		${StyledContainer}:hover & {
			color: #000;
		}

		${StyledContainer}.active & {
			color: #ffffff;
		}
	}
`;

const StyledFuelName = styled.div<{
	$color?: string;
}>`
	position: relative;
	text-indent: 16px;
	line-height: 16px;

	&::after {
		content: '';
		position: absolute;
		left: 0;
		top: 50%;
		width: 6px;
		height: 6px;
		border-radius: 6px;
		transform: translateY(-50%);
		background-color: ${({ $color }) => $color ?? '#fff'};
		transition: background-color 0.25s ease;
	}

	${StyledContainer}:hover &::after,
	${StyledContainer}.active &::after {
		background-color: ${({ $color }) => $color ?? '#000'};
	}
`;

const StyledFuelPrice = styled.div`
	line-height: 18px;

	span {
		color: #fff;
		opacity: 0.5;
		transition: color 0.25s ease;

		${StyledContainer}:hover & {
			color: #000;
		}

		${StyledContainer}.active & {
			color: #fff;
		}
	}
`;

export {
	StyledBackgroundNumber,
	StyledContainer,
	StyledFuelName,
	StyledFuelPrice,
	StyledInnerContainer,
};
